import { Error as CwbApiError } from "@amzn/client-workbench-api-model";
import { AxiosResponse } from "axios";
import React from "react";
import { FormattedMessage } from "react-intl";

import ErrorBanner from "@/components/Commons/ErrorBanner/ErrorBanner";

type SendPinErrorProps = {
  error: AxiosResponse<CwbApiError, any>;
};

/**
 * Get the appropriate message id for the given error.
 * @param error The error to get the message id for
 */
function getMessageId(error: AxiosResponse<CwbApiError, any>): string {
  if (error && error.status === 429) {
    return "registerSecurityKey-button-sendTempPin-requestLimitErrorContactSupport";
  }
  if (error && error.data) {
    switch (error.data.supplementalStatusCode) {
      case 3100:
        return "registerSecurityKey-button-midwayPinIssue-errorContactSupport";
      case 3200:
        return "registerSecurityKey-button-midwayEmailIssue-errorContactSupport";
      case 3300:
        return "registerSecurityKey-button-midwayDateIssue-errorContactSupport";
      default:
        return "registerSecurityKey-button-sendTempPin-error";
    }
  }
  return "registerSecurityKey-button-sendTempPin-error";
}

/**
 * The error message to inform NHs when there are some issues with their accounts.
 */
export const SendPinError = ({ error }: SendPinErrorProps): JSX.Element => {
  return (
    <ErrorBanner>
      <FormattedMessage id={getMessageId(error)} />
    </ErrorBanner>
  );
};
